let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ek3qx")).then(() => parcelRequire('dVNXt'));